import {
  UI_LOCALE_OPTIONS,
  useI18n,
  useMessages,
} from "../../i18n";
import { languageSettingsMessages } from "./languageSettingsMessages";
import {
  focusRadioAtIndex,
  nextLocaleOptionIndex,
} from "./localePickerKeyboard";
import "./localeQuickSwitch.css";

export interface LocaleQuickSwitchProps {
  readonly className?: string;
}
export function LocaleQuickSwitch({
  className,
}: LocaleQuickSwitchProps) {
  const { locale, localePersistence, setLocale } = useI18n();
  const t = useMessages(languageSettingsMessages);

  return (
    <div
      className={[
        "locale-quick-switch",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      role="radiogroup"
      aria-label={t("regionLabel")}
      data-persistence={localePersistence}
      title={
        localePersistence === "unavailable"
          ? t("persistenceWarning")
          : undefined
      }
    >
      {UI_LOCALE_OPTIONS.map((option, index) => {
        const selected = option.id === locale;
        return (
          <button
            key={option.id}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={
              selected
                ? t("selected", {
                    language: option.nativeLabel,
                  })
                : t("changeTo", {
                    language: option.nativeLabel,
                  })
            }
            data-selected={selected ? "true" : "false"}
            tabIndex={selected ? 0 : -1}
            onClick={() => setLocale(option.id)}
            onKeyDown={(event) => {
              const nextIndex = nextLocaleOptionIndex(
                event.key,
                index,
                UI_LOCALE_OPTIONS.length,
              );
              if (nextIndex === null) {
                return;
              }
              event.preventDefault();
              setLocale(UI_LOCALE_OPTIONS[nextIndex].id);
              focusRadioAtIndex(event, nextIndex);
            }}
          >
            {option.shortLabel}
          </button>
        );
      })}
      <span className="sr-only" aria-live="polite">
        {localePersistence === "unavailable"
          ? t("persistenceWarning")
          : ""}
      </span>
    </div>
  );
}
